import axios from 'axios'
export const LinkAPI ="https://kaynapp.herokuapp.com" 
 export const Confirmchangeemail =(Token)=>{
  axios.put(`${LinkAPI}/api/businessowner/confirmchangeemail`,{},{
      headers:{
        Authorization:`${Token}`
      }
    }).then(res =>{
      console.log(res) 
      localStorage.setItem("userToken",res.data.token)
     
      }).catch(error=>{
      console.log(error.response)
      })
}
 export const ClientInfo =(Token)=>{
  axios.get(`${LinkAPI}/api/businessowner/getinfo`,{
    headers:{
      Authorization:`${Token}`
    }
  }
    ).then(res =>{
      const data = res.data.businessOwner 
      console.log(data)
      return data
      }).catch(error=>{
      console.log(error.response.data.message)
      })
}